<template>
    <div v-if="loaded" class="wrapper link">
        <div class="content">
            <main class="container">
                <div class="row">
                    <div class="col-sm-4">
                        <h2 class="sf2__title--under-stroke">Le nostre tariffe parlano chiaro.</h2>
                        <p>Scegli quella che fa per te con il profilo più adatto alle tue esigenze.</p>
                    </div>
                    <div class="col-sm-8 estimator">
                        <div class="estimator_box">
                            <div class="row estimator_head_box">
                                <div class="col-sm-6 centred">
                                    <span class="estimator_title">CORRISPETTIVI*</span>
                                </div>
                                <div class="col-sm-2 centred">
                                    <span class="estimator_rate_label">Tariffa Luce</span>
                                </div>
                                <div class="col-sm-4 centred">
                                    <div class="estimator_toggle_box">
                                        <button v-bind:class="[rateType == 'singleHourly' ? 'single_hourly' : '']" v-on:click='changeSingle()'>Monoraria</button>
                                        <button v-bind:class="[rateType == 'doubleHourly' ? 'double_hourly' : '']" v-on:click='changeDouble()'>Bioraria</button>
                                    </div>
                                </div>
                            </div>

                            <div class="estimator_rates row">
                                <div v-bind:class="[rateType == 'doubleHourly' ? 'col-sm-8' : 'col-sm-6']">
                                    <div class="energy_box" v-bind:class="energySelected">
                                        <div class="row">
                                            <div v-bind:class="[rateType == 'doubleHourly' ? 'col-sm-6' : 'col-sm-12']">
                                                <EstimatorItem v-if="rateType == 'doubleHourly'" :item-price="f1" itemTitle="LUCE F1" itemValue="€/kWh" tooltipText="8:00 - 19:00<br>lun-ven escluse festività"></EstimatorItem>
                                                <EstimatorItem v-else :item-price="f" itemTitle="LUCE h24" itemValue="€/kWh" tooltipText="tutti i giorni"></EstimatorItem>
                                            </div>

                                            <div v-if="rateType == 'doubleHourly'" class="col-sm-6">
                                                <EstimatorItem :item-price="f2" itemTitle="LUCE F2-F3" itemValue="€/kWh" tooltipText="19:00 - 08:00<br>weekend e festività"></EstimatorItem>
                                            </div>
                                        </div>

                                        <label class="coustom_checkbox_container">
                                            <input type="checkbox" value="energy" v-model="checkedRates"/>
                                            <span></span>
                                        </label>
                                    </div>
                                </div>

                                <div v-bind:class="[rateType == 'doubleHourly' ? 'col-sm-4' : 'col-sm-6']">
                                    <div class="gas_box" v-bind:class="gasSelected">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <EstimatorItem :item-price="gas" itemTitle="GAS" itemValue="€/Smc"></EstimatorItem>
                                            </div>
                                        </div>

                                        <label class="coustom_checkbox_container">
                                            <input type="checkbox" value="gas" v-model="checkedRates"/>
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="text_info">
                                I prezzi mostrati si intendono già al netto dello sconto digitale: scegli l’Addebito su conto corrente e la Bolletta digitale per riceverlo.
                            </div>

                            <div class="activation_area">
                                <button class="sf2-btn colorize-bg" sf-cart-modal-switch="slide-up" :disabled="checkedRates < 1">Attiva <b>LINK</b></button>
                                <a href="javascript:openForm();"><span class="icon-CTA-telefono"></span>Ti chiamiamo noi</a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>

    import EstimatorItem from './EstimatorItem.vue';

    export default {
        name: "Estimator",

        components: {
            EstimatorItem
        },

        props: {
            f: Number,
            f1: Number,
            f2: Number,
            gas: Number
        },

        data() {
            return {
                loaded: true,
                commodity: '',
                tab: "path",
                exitPage: {},
                recap: [],
                path: [],
                answersPath: [],
                rateType: "singleHourly",
                checkedRates: ['energy', 'gas'],
                cartOption: String,
                cartUtility: String
            }
        },

        created: function () {},

        mounted() {},

        computed: {
            energySelected: function() {
                this.$emit("cart-utility", this.checkedRates);
                return this.checkedRates.map(item => item == "energy" ? "selected" : "");
            },

            gasSelected: function() {
                return this.checkedRates.map(item => item == "gas" ? "selected" : "");
            }
        },

        methods: {
            changeSingle() {
                this.cartOption="Monoraria";
                this.$emit("cart-option", this.cartOption);
                this.rateType = "singleHourly";
            },

            changeDouble() {
                this.cartOption="Bioraria";
                this.$emit("cart-option", this.cartOption);
                this.rateType = "doubleHourly";
            }
        }
    }

</script>

<style lang="scss">

    .estimator {
        color: #333333;

        .centred {
            display: flex;
            align-items: center;
            height: inherit;
        }

        &_box {
            background: white;
            width: 100%;
            padding: 30px;
            border-radius: 10px;
            box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.15);
        }

        &_head_box {
            height: 40px;
        }

        &_title {
            font-size: 20px;
            font-weight: bold;
        }

        &_rate_label {
            font-weight: bold;
        }

        &_toggle_box {
            display: flex;
            background: #f4f4f4;
            height: 40px;
            border-radius: 10px;
            width: 210px;

            button {
                background: transparent;
                border: none;
                height: inherit;
                border-radius: 10px;
                font-size: 13px;
                color: #767676;
                width: 50%;

                &.single_hourly, &.double_hourly {
                    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.15);
                    background: #7fa545;
                    font-weight: bold;
                    color: white;
                }
            }
        }

        &_rates {
            .energy_box, .gas_box {
                position: relative;
                margin-top: 30px;
                border-radius: 10px;
                padding: 15px;
                border: 2px solid #eaeaea;

                &.selected {
                    border: 2px solid #7fa545;
                }

                .coustom_checkbox_container {
                    margin: 15px 15px 0 0;
                    position: absolute;
                    top: 0;
                    right: 0;

                    input[type="checkbox"] {
                        display: none;
                    }

                    input[type="checkbox"] + *::before {
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                        border-radius: 6px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        content: "";
                        vertical-align: bottom;
                        border: 2px solid #eaeaea;
                    }

                    input[type="checkbox"]:checked + *::before {
                        content: "\e97c";
                        font-family: 'EGL-Icon-font' !important;
                        color: white;
                        background: #7fa545;
                        border-color: #7fa545;
                    }

                    input[type="checkbox"]:checked + * {
                        color: #7fa545;
                    }
                }
            }
        }

        .text_info {
            margin: 15px 0 30px 0;
            font-size: 12px;
            color: #767676;
        }

        .activation_area {
            display: flex;
            justify-content: space-around;

            a { 
                line-height: 45px; border: 1px solid #333333; display: inline-block; width: 300px; text-align: center;
                border-radius: 3px;
            }

            button {
                max-width: 300px;
                
                &:disabled {
                    background: #767676; opacity: 0.3;
                }
            }
        }
    }

</style>